var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHibooks1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 58,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "9.0 3.0 48.0 58.0",
    width: 48,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,3h-5c-1.105,0-2,0.895-2,2c0,1.105-0.895,2-2,2h-8c-1.105,0-2-0.895-2-2c0-1.105-0.895-2-2-2h-5 c-2.761,0-5,2.239-5,5v48c0,2.761,2.239,5,5,5h26c2.761,0,5-2.239,5-5V8C45,5.239,42.761,3,40,3z",
    fill: "#d6dee0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change2_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,57H15c-1.105,0-2-0.895-2-2V9c0-1.105,0.895-2,2-2h23c1.105,0,2,0.895,2,2v46 C40,56.105,39.105,57,38,57z",
    fill: "#a1c6ed"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change3_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,5c0,1.105,0.895,2,2,2h8c1.105,0,2-0.895,2-2c0-1.105,0.895-2,2-2H19C20.105,3,21,3.895,21,5z",
    fill: "#c8cfd1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,17c-2.209,0-4,1.791-4,4h8C31,18.791,29.209,17,27,17z",
    fill: "#d6dee0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "change4_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,39H18c-0.552,0-1-0.448-1-1V22c0-0.552,0.448-1,1-1h13V39z",
    fill: "#9c6721"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "change5_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 21H31V39H27z",
    fill: "#8c5d1e"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "change1_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,46c0,1.657-1.343,3-3,3h11h8c2.209,0,4-1.791,4-4v-2h-6H37V46z",
    fill: "#d6dee0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "change6_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,21v25c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h14V21c0-2.209-1.791-4-4-4h-2H27 C29.209,17,31,18.791,31,21z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "change7_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 30,
    fill: "#fcbc04",
    r: 7
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "change6_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,44h9c0.552,0,1-0.448,1-1l0,0c0-0.552-0.448-1-1-1h-9c-0.552,0-1,0.448-1,1l0,0 C17,43.552,17.448,44,18,44z",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "change6_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,48h9c0.552,0,1-0.448,1-1l0,0c0-0.552-0.448-1-1-1h-9c-0.552,0-1,0.448-1,1l0,0 C17,47.552,17.448,48,18,48z",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "change6_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,52h9c0.552,0,1-0.448,1-1l0,0c0-0.552-0.448-1-1-1h-9c-0.552,0-1,0.448-1,1l0,0 C17,51.552,17.448,52,18,52z",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "change6_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,12H18c-0.552,0-1,0.448-1,1v0c0,0.552,0.448,1,1,1h17c0.552,0,1-0.448,1-1v0 C36,12.448,35.552,12,35,12z",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "change6_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,28v-1c0-0.552-0.447-1-1-1h-1v-1h-2v1h-1c-0.553,0-1,0.448-1,1v3c0,0.552,0.447,1,1,1h3v1h-4v1 c0,0.552,0.447,1,1,1h1v1h2v-1h1c0.553,0,1-0.448,1-1v-3c0-0.552-0.447-1-1-1h-3v-1H44z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibooks1);
export default __webpack_public_path__ + "static/media/hibooks1.a5d664b9ad2271dba6432ff16e5bebd4.svg";
export { ForwardRef as ReactComponent };